
<div
  class="modal fade in"
  id="DigilockerMethodModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h5 class="modal-title">DigiLoacker Verification Method</h5>
        <button
          type="button"
          (click)="onCloseDigilockerMethodModal()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div style =" display: flex; justify-content: center; gap: 0.3125rem; ">
          
          <button id="start-verification-btn" class="btn btn-primary mt-3 font-size-12 button-btn" (click) ="opendigiboostsdk()">
            Verify Using SDK
          </button>
          <button id="start-verification-btn" class="btn btn-primary mt-3 font-size-12 button-btn">
            Verify Using Link
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade in"
  id="wedsdkModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h5 class="modal-title">DigiLocker SDK</h5>
        <button
          type="button"
          (click)="onclosewebsdkModal()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body sdkmodel">
        
        <div class="digilocker-card">
        <div class="digilocker-icon">
          <i class="fas fa-shield-alt"></i>
        </div>

        <h3 class="digilocker-title">Document Verification</h3>
        <p class="digilocker-subtitle">
          Securely access your documents through DigiLocker
        </p>

        <ul class="digilocker-features">
          <li><i class="fas fa-bolt"></i> Instant Access — get immediate access to your verified documents</li>
          <li><i class="fas fa-lock"></i> Secure & Trusted — Government-backed digital document platform</li>
        </ul>

        <div class="digilocker-cta">
          <p class="digilocker-info">Ready to proceed?</p>
          <p class="digilocker-desc">
            Click the button below to securely connect with DigiLocker and access your documents
          </p>
          <div id="digilocker-sdk-container">
          <div id="digilocker-button"></div>
          </div>
        </div>

        <div id="status">{{ statusMessage }}</div>
      </div>

      </div>
    </div>
  </div>
</div>